import { actionTypes } from "../constants/ActionTypes";

import {store} from '../store/index'

export default (state = store.loader, action) => {
    switch (action.type) {
        case actionTypes.SET_LOADER:
        return Object.assign({}, state, {
            loader:  action.data,
        }) 

        default:
            return state;
        }
}